// extracted by mini-css-extract-plugin
export default {"header":"header--lb8Et","title":"title--d0FJk","attachments":"attachments--Uo1vT","info":"info--OxYi9","moreButton":"moreButton--weGq0","form":"form--Mfiug","footer":"footer--EbE7O"};